var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeftMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 2.5H2.14976C1.51463 2.5 0.999756 3.01487 0.999756 3.65C0.999756 4.28513 1.51463 4.8 2.14976 4.8H19.8498C20.4849 4.8 20.9998 4.28513 20.9998 3.65C20.9998 3.01487 20.4849 2.5 19.8498 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 9.85156H2.14976C1.51463 9.85156 0.999756 10.3664 0.999756 11.0016C0.999756 11.6367 1.51463 12.1516 2.14976 12.1516H19.8498C20.4849 12.1516 20.9998 11.6367 20.9998 11.0016C20.9998 10.3664 20.4849 9.85156 19.8498 9.85156Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 17.1992H2.14976C1.51463 17.1992 0.999756 17.7141 0.999756 18.3492C0.999756 18.9843 1.51463 19.4992 2.14976 19.4992H19.8498C20.4849 19.4992 20.9998 18.9843 20.9998 18.3492C20.9998 17.7141 20.4849 17.1992 19.8498 17.1992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftMenu);
export default __webpack_public_path__ + "static/media/icon-left-menu.d16df0ad7b76f4ea10d26fcae5e3b04d.svg";
export { ForwardRef as ReactComponent };